import React from 'react';

export default function TrialBalance() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Trial Balance</h1>
      <p className="text-gray-500">Halaman Trial Balance</p>
    </div>
  );
}
